



import { Vue, Component } from "vue-property-decorator";
import Order from "@/components/cutomer/order.vue";
import VueScrollTo from "vue-scrollto";

@Component({
  name: "CustomerOrder",
  components: {
    Order,
  },
})
export default class CustomerOrder extends Vue {
  mounted() {
    VueScrollTo.scrollTo({ force: true });
  }
  get orderId() {
    return this.$route.params.id;
  }
}
